import { ChangeEvent } from "react";

export class FauxChangeEvent<T> implements ChangeEvent<T> {
    constructor(public target: EventTarget & T, eventInit?: EventInit) {
        this.currentTarget = target;
        this.nativeEvent = new CustomEvent("change", eventInit);
        Object.defineProperty(this.nativeEvent, "target", {
            value: target,
            writable: false,
            configurable: false,
            enumerable: true,
        });
    }

    nativeEvent: Event;
    currentTarget: EventTarget & T;
    private _isPropagationStopped = false;

    get bubbles(): boolean {
        return this.nativeEvent.bubbles;
    }

    get cancelable(): boolean {
        return this.nativeEvent.cancelable;
    }

    get defaultPrevented(): boolean {
        return this.nativeEvent.defaultPrevented;
    }

    get eventPhase(): number {
        return this.nativeEvent.eventPhase;
    }

    get isTrusted(): boolean {
        return this.nativeEvent.isTrusted;
    }

    get timeStamp(): number {
        return this.nativeEvent.timeStamp;
    }

    get type(): string {
        return this.nativeEvent.type;
    }

    preventDefault(): void {
        this.nativeEvent.preventDefault();
    }

    isDefaultPrevented(): boolean {
        return this.defaultPrevented;
    }

    stopPropagation(): void {
        this.nativeEvent.stopPropagation();
        this._isPropagationStopped = true;
    }

    isPropagationStopped(): boolean {
        return this._isPropagationStopped;
    }

    persist(): void {
        throw new Error("This is not a real React ChangeEvent. React does not permit the creation of SyntheticEvents in userland.");
    }
}
